document.addEventListener('DOMContentLoaded', function() {
  let selectedQuantity = 0;
  let selectedVariants = [];
  let productTitle = "";
  let originalPrice = 0;
  let discountedPrice = 0;

  const step1Panel = document.getElementById('step1-panel');
  const step2Panel = document.getElementById('step2-panel');
  const nextStepButton = document.getElementById('next-step-button');
  const backButton = document.getElementById('back-button');
  const addToCartButton = document.getElementById('add-to-cart-button');
  const selectionDisplay = document.getElementById('selection-display');
  const selectionTitle = document.getElementById('selection-title');
  const selectionTotal = document.getElementById('selection-total');

  // Step 1: Quantity Selection
  const quantityCards = document.querySelectorAll('.quantity-card');
  quantityCards.forEach(card => {
    card.addEventListener('click', function() {
      selectQuantityCard(this);
    });
  });

  function selectQuantityCard(card) {
    quantityCards.forEach(c => c.classList.remove('selected'));
    card.classList.add('selected');
    selectedQuantity = parseInt(card.dataset.quantity);
    nextStepButton.disabled = false;

    // Get selected title
    productTitle = card.querySelector('.product-bundle--title').textContent.trim();
    // Calculate prices
    originalPrice = (parseFloat(card.dataset.originalPrice) / 100) * selectedQuantity;
    discountedPrice = (parseFloat(card.dataset.price) / 100) * selectedQuantity;
  }

  // Initialize with the first item selected
  function init() {
    if (quantityCards.length > 0) {
      selectQuantityCard(quantityCards[0]);
    }
  }

  // Call the init function
  init();

  // Next Step Button
  nextStepButton.addEventListener('click', function() {
    step1Panel.style.display = 'none';
    step2Panel.style.display = 'block';
    generatePlaceholders();
    updateSelectionHeader();
  });

  // Back Button
  backButton.addEventListener('click', function() {
    step1Panel.style.display = 'block';
    step2Panel.style.display = 'none';
    selectedVariants = [];
  });

  // Generate placeholders based on selected quantity
  function generatePlaceholders() {
    selectionDisplay.innerHTML = '';
    for (let i = 0; i < selectedQuantity; i++) {
      const placeholder = document.createElement('div');
      placeholder.className = 'selection-placeholder';
      placeholder.innerHTML = `
        <p>POM #${i + 1}</p>
      `;
      selectionDisplay.appendChild(placeholder);
    }
  }

  // Function to update the selection header
  function updateSelectionHeader() {
    selectionTitle.textContent = `Your ${productTitle} includes:`;
    selectionTotal.innerHTML = `
      <span class="original-price">$${originalPrice.toFixed(2)}</span>
      <span class="discount-price">$${discountedPrice.toFixed(2)}</span>
    `;
  }

  // Step 2: Variant Selection

  // tabs to display colors
  const tabButtons = document.querySelectorAll('.tab-button');
  const variantOptions = document.querySelectorAll('.variant-options');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const tab = button.getAttribute('data-tab');
      
      tabButtons.forEach(btn => btn.classList.remove('active'));
      variantOptions.forEach(option => option.classList.remove('active'));
  
      button.classList.add('active');
      document.querySelector(`.variant-options[data-tab-content="${tab}"]`).classList.add('active');
    });
  });
  
  document.querySelectorAll('.variant-card').forEach(button => {
    button.addEventListener('click', function() {
      //const variantCard = this.closest('.variant-card');
      const variantId = this.dataset.variantId;
      const variantTitle = this.querySelector('.variant-card--title').textContent;
      const variantImage = this.querySelector('img').src;
      if (selectedVariants.length < selectedQuantity) {
        addVariantToSelection(variantId, variantTitle, variantImage);
      }
    });
  });

  function addVariantToSelection(variantId, variantTitle, variantImage) {
    const emptyPlaceholder = selectionDisplay.querySelector('.selection-placeholder:not(.filled)');
    if (emptyPlaceholder) {
      emptyPlaceholder.classList.add('filled');
      emptyPlaceholder.innerHTML = `
        <div class="variant-card--image"><img src="${variantImage}" alt="${variantTitle}"></div>
        <div class="variant-card--title">${variantTitle}</div>
        <button class="remove-variant" data-variant-id="${variantId}">&times;</button>
      `;
      selectedVariants.push(variantId);
      updateAddToCartButton();
    }
  }

  // Remove variant
  selectionDisplay.addEventListener('click', function(e) {
    if (e.target.classList.contains('remove-variant')) {
      const variantId = e.target.dataset.variantId;
      const placeholderToReset = e.target.closest('.selection-placeholder');
      placeholderToReset.classList.remove('filled');
      placeholderToReset.innerHTML = `
        <p>POM #${Array.from(selectionDisplay.children).indexOf(placeholderToReset) + 1}</p>
      `;
      selectedVariants = selectedVariants.filter(id => id !== variantId);
      updateAddToCartButton();
    }
  });

  function updateAddToCartButton() {
    addToCartButton.disabled = selectedVariants.length !== selectedQuantity;
  }


  // Add to Cart Button
  addToCartButton.addEventListener('click', function() {
    // Disable the button to prevent multiple clicks
    this.disabled = true;
    
    // Prepare the items array for the cart
    let items = selectedVariants.map(variantId => ({
      id: variantId,
      quantity: 1
    }));
  
    // Use Shopify's AJAX API to add items to the cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Items added to cart:', data);
      
      // Create and dispatch the ajaxProduct:added event
      const addedEvent = new CustomEvent('ajaxProduct:added', {
        detail: {
          items: data
        }
      });
      document.dispatchEvent(addedEvent);
      
      // Re-enable the button
      this.disabled = false;
      
      // Reset the selection if needed
      resetSelection();
    })
    .catch(error => {
      console.error('Error adding items to cart:', error);
      // Re-enable the button
      this.disabled = false;
      // Show an error message
      const errorEvent = new CustomEvent('cart:error', {
        detail: {
          error: error.description || 'There was an error adding items to your cart. Please try again.'
        }
      });
      document.dispatchEvent(errorEvent);
    });
  });

  // Function to reset the selection after successful add to cart
  function resetSelection() {
    // Reset selected variants
    selectedVariants = [];
    
    // Reset the display
    generatePlaceholders();
    
    // Disable add to cart button
    addToCartButton.disabled = true;
    
    // Optionally, go back to step 1
    step1Panel.style.display = 'block';
    step2Panel.style.display = 'none';
    
    // Remove selected state from quantity cards
    document.querySelectorAll('.quantity-card').forEach(card => {
      card.classList.remove('selected');
    });
    
    // Reset quantity
    selectedQuantity = 0;
    
    // Reset prices
    originalPrice = 0;
    discountedPrice = 0;
  }

});